import classNames from 'classnames'
import styles from './LayoutGrid.module.css'
import type { LayoutGridProps } from './types'

function LayoutGrid({
  children,
  space = '200',
  columns,
  minElementWidth,
  flex,
  style,
  justify,
  className,
}: LayoutGridProps) {
  return (
    <div
      className={classNames(styles.grid, justify && styles[`justify-${justify}`], className, {
        [styles.gridAutoFit as string]: !columns && minElementWidth,
        [styles.gridColumns as string]: !!columns,
        [styles.flex!]: flex,
      })}
      style={
        {
          ...style,
          '--space': `var(--betterplace-spacing-${space})`,
          //   We might want to extend this to use our tokens
          '--min': minElementWidth,
          '--columns': columns,
        } as React.CSSProperties
      }
    >
      {children}
    </div>
  )
}

export default LayoutGrid
